const routes = [
  {
    path: "/calendar",
    name: "MyCalendar",
    component: () =>
      import(
        /* webpackChunkName: "mycalendar" */ "@/pages/MyCalendar/MyCalendarIndex"
      ),
    meta: {
      title: "My Calendar - NutriBit",
      showSearch: true
    }
  }
];

export default routes;
